import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import ToastComponent from "../../components/ToastCompoent/ToastComponent";
import { setContactTabValue, setTabValue } from "../../Reducer/localStorageSlice";
import "./experienceOfWork.scss";
// import CardList from "./newUx/CardList/CardList";
import ExperienceOfWorkCardList from "./newUx/CardList/ExperienceOfWorkCardList";

export default function ExperienceOfWork({ changeTab }) {
  const dispatch = useDispatch()
  const localData = useSelector((state) => state?.localStorage)
  const { micrositeID } = localData
  const [loading, setLoading] = useState(true);
  const [activeKey,] = useState("work-experience");
  const [responseData, setResponseData] = useState([]);
  const [mediaType, setMediaType] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const id = micrositeID

  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const color = [
    "#E75E0D",
    "#EB9F11",
    "#ABC710",
    "#009340",
    "#CC0370",
    "#8366A9",
    "#149BD7",
  ];


  const getExperienceOfWork = async () => {
    try {
      setLoading(true);
      if (id) {
        const response = await getRequest(
          userapiservice.getExperienceOfWork(id)
        );
        setResponseData(response);

        setLoading(false);
      }
    } catch (error) {
      toast.error(<ToastComponent type={'Error'} message={`${error?.error || 'Something went wrong'}`} />);
      setLoading(false);
    }
  };
  useEffect(() => {
    getExperienceOfWork(activeKey, id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeKey, id]);

  const PlayVideoHandler = (url, mediaType) => {
    setMediaType(mediaType);
    setVideoUrl(url);
    setIsModalOpen(true);
  };

  const convertToStandardURL = (shortUrl) => {
    if (shortUrl?.indexOf("youtu.be") !== -1) {
      const video_id = shortUrl?.split("youtu.be/")[1].split("?")[0];
      return `https://www.youtube.com/watch?v=${video_id}`;
    }
    return shortUrl;
  };

  const onCardClickHandler = (data) => {
    if (data?.experienceOfWorkOpportunityOutput?.description) {
      navigate(`/microsite/${data.id}/micrositeDetails`, {
        state: { page: activeKey, data: data },
      });
      dispatch(setTabValue('work-experience'))
    } else {
      changeTab("EXPERIENCES_OF_WORK");
      dispatch(setContactTabValue("EXPERIENCES_OF_WORK"))
    }

    if (data?.experienceOfWorkOpportunityOutput?.media) {
      const payload = {
        description: data.experienceOfWorkOpportunityOutput.description,
        title: data.experienceOfWorkTitle,
        mediaLink: {
          mediaType: data.experienceOfWorkOpportunityOutput.media.mediaType,
          url: data.experienceOfWorkOpportunityOutput.media.url,
        },
      };

      navigate(`/microsite/${data.id}/micrositeDetails`, {
        state: { page: activeKey, data: payload },
      });
    } else {
      // changeTab("EXPERIENCES_OF_WORK");
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setVideoUrl("");
  };

  if (loading) {
    return (
      <div
        className="ant-tabs-content-holder"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="loader">
          <Spin tip="Loading" size="large" />
        </div>
      </div>
    );
  } else {
    return (
      <ExperienceOfWorkCardList
        responseData={responseData}
        color={color}
        PlayVideoHandler={PlayVideoHandler}
        convertToStandardURL={convertToStandardURL}
        isModalOpen={isModalOpen}
        handleCancel={handleCancel}
        videoUrl={videoUrl}
        mediaType={mediaType}
        onCardClickHandler={onCardClickHandler}
      />
    );
  }
}
